import { watch, onMounted } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// #26 — mostra a quantidade de não-lidas no título da aba do navegador
// ("(15) AstraChat"), estilo WhatsApp Web. Útil pra quem usa o app encapsulado.
// Aditivo: um watcher sem tocar no layout/roteador.
//
// Fonte da contagem: `notifications/getUnreadCount` — a mesma usada no badge do
// item "Inbox" da sidebar. É atualizada direto pelo payload do socket
// (notification.created/updated/deleted), sem round-trip de rede nem throttle,
// então some/atualiza em tempo real. `conversationUnreadCounts/getAllUnreadCount`
// foi cogitado mas depende de um fetch feito pela Sidebar + ActionCable com
// throttle de 5s e escopo por membros do inbox — fica defasado sem F5.
export function useUnreadDocumentTitle() {
  const count = useMapGetter('notifications/getUnreadCount');
  let base = '';

  const apply = () => {
    const n = Number(count.value) || 0;
    document.title = n > 0 ? `(${n}) ${base}` : base;
  };

  onMounted(() => {
    // título base = o que veio no <head> (INSTALLATION_NAME), sem prefixo antigo
    base = (document.title || '').replace(/^\(\d+\)\s*/, '');
    apply();
  });

  watch(count, apply);
}
